import styled from 'styled-components';

import { BreakPoint } from '@makemydeal/dr-activities-common';
import { MAX_APP_CONTAINER_WIDTH_NEW } from '@makemydeal/dr-shared-ui-utils';

export const ActionsContainer = styled.div<{
    flexDirection?: string;
}>`
    display: flex;
    flex-direction: ${({ flexDirection }) => flexDirection || 'column-reverse'};
    background-color: ${({ theme }) => theme.tokens.BaseColorWhite};
    gap: 1rem;

    width: 100%;
    max-width: ${MAX_APP_CONTAINER_WIDTH_NEW};
    margin: 0 auto;

    box-shadow: 'none';
    padding: 16px;

    .desking-btn-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
    .share-container-buttons {
        display: flex;
        flex-direction: column-reverse;
        gap: 16px;
    }
    .save-template-button-container {
        margin-left: auto;
    }

    @media (max-width: ${BreakPoint.SCREEN_MD_MIN}) {
        .deal-comments-button {
            width: 100% !important;

            button {
                width: 100% !important;
            }
        }
    }

    @media (min-width: ${BreakPoint.SMALL}) {
        margin-top: 0;
        flex-direction: ${({ flexDirection }) => flexDirection || 'row'};

        .desking-btn-container {
            flex: 1;
            flex-direction: row;
        }

        .share-container-buttons {
            flex-direction: row;
        }
    }
`;

export const FooterPlaceholder = styled.div`
    height: 13rem;

    @media (min-width: ${BreakPoint.SMALL}) {
        height: 5.867rem;
    }
`;

// NOTE: This is a fix to show the shadow on the top side of the container only
export const CutOffShadowContainer = styled.div`
    width: 100%;
    max-width: ${MAX_APP_CONTAINER_WIDTH_NEW};
    margin: 0 auto;
    overflow-x: clip;
`;

export const StickyFooter = styled.div`
    position: sticky;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1001;
`;
